import { render, staticRenderFns } from "./ByCollege.vue?vue&type=template&id=a5c18a5a&scoped=true&"
import script from "./ByCollege.vue?vue&type=script&lang=js&"
export * from "./ByCollege.vue?vue&type=script&lang=js&"
import style0 from "./ByCollege.vue?vue&type=style&index=0&id=a5c18a5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5c18a5a",
  null
  
)

export default component.exports